import { useEffect } from 'react'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

const PIXEL_ID = '26568283156091009'

function initPixel() {
  if (window.fbq) return

  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })
  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  window.fbq('init', PIXEL_ID)
}

export function useMetaPixel() {
  useEffect(() => {
    initPixel()
    window.fbq('track', 'PageView')
  }, [])
}

export function trackAddToCart() {
  if (window.fbq) {
    window.fbq('track', 'AddToCart')
  }
}
